import { TFunction } from "i18next";

import { AcceptenceCriteriaColors } from "./temperatures";

//increase 0.1 each time
export const START_PH_OPTIONS = Array.from({ length: 121 }, (_, index) => ({
  value: Number((1 + index * 0.1).toFixed(1)),
  label: "pH: " + (1 + index * 0.1).toFixed(1).toString(),
  color: AcceptenceCriteriaColors.Acceptable,
}));

export const END_PH_OPTIONS = [
  {
    value: 4.8,
    label: "pH: >4.7",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.7,
    label: "pH: 4.7",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.6,
    label: "pH: 4.6",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.5,
    label: "pH: 4.5",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.4,
    label: "pH: 4.4",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.3,
    label: "pH: 4.3",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.2,
    label: "pH: 4.2",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.1,
    label: "pH: 4.1",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  { value: 4.0, label: "pH: 4.0", color: AcceptenceCriteriaColors.Acceptable },
  { value: 3.9, label: "pH: 3.9", color: AcceptenceCriteriaColors.Acceptable },
  { value: 3.8, label: "pH: 3.8", color: AcceptenceCriteriaColors.Acceptable },
  { value: 3.7, label: "pH: 3.7", color: AcceptenceCriteriaColors.Acceptable },
  { value: 3.6, label: "pH: 3.6", color: AcceptenceCriteriaColors.Acceptable },
  { value: 3.5, label: "pH: 3.5", color: AcceptenceCriteriaColors.Acceptable },
  { value: 3.4, label: "pH: 3.4", color: AcceptenceCriteriaColors.Acceptable },
  { value: 3.3, label: "pH: <3.4", color: AcceptenceCriteriaColors.Acceptable },
];

export const END_PH_48_HOURS_OPTIONS = [
  {
    value: 5.1,
    label: "pH: >5.0",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 5.0,
    label: "pH: 5.0",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.9,
    label: "pH: 4.9",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.8,
    label: "pH: 4.8",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.7,
    label: "pH: 4.7",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.6,
    label: "pH: 4.6",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.5,
    label: "pH: 4.5",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  { value: 4.4, label: "pH: 4.4", color: AcceptenceCriteriaColors.Acceptable },
  { value: 4.3, label: "pH: 4.3", color: AcceptenceCriteriaColors.Acceptable },
  { value: 4.2, label: "pH: 4.2", color: AcceptenceCriteriaColors.Acceptable },
  { value: 4.1, label: "pH: 4.1", color: AcceptenceCriteriaColors.Acceptable },
  { value: 4.0, label: "pH: 4.0", color: AcceptenceCriteriaColors.Acceptable },
  { value: 3.9, label: "pH: <4.0", color: AcceptenceCriteriaColors.Acceptable },
];

export const sushiRicePhOptions = (t: TFunction) => [
  {
    value: "100",
    label: "pH: >5.0",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "5.0",
    label: "pH: 5.0",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "4.9",
    label: "pH: 4.9",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "4.8",
    label: "pH: 4.8",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "4.7",
    label: "pH: 4.7",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "4.6",
    label: "pH: 4.6",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "4.5",
    label: "pH: 4.5",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "4.4",
    label: "pH: 4.4",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "4.3",
    label: "pH: 4.3",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "4.2",
    label: "pH: 4.2",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "4.1",
    label: "pH: 4.1",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "4.0",
    label: "pH: 4.0",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-100",
    label: "pH: <4.0",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-101",
    label: t("food.Rice is discarded in three hours"),
    color: AcceptenceCriteriaColors.Acceptable,
  },
];

export const PICKLES_PH_OPTIONS = [
  {
    value: 5.1,
    label: "pH: >5.0",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 5.0,
    label: "pH: 5.0",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.9,
    label: "pH: 4.9",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.8,
    label: "pH: 4.8",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.7,
    label: "pH: 4.7",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.6,
    label: "pH: 4.6",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: 4.5,
    label: "pH: 4.5",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  { value: 4.4, label: "pH: 4.4", color: AcceptenceCriteriaColors.Acceptable },
  { value: 4.3, label: "pH: 4.3", color: AcceptenceCriteriaColors.Acceptable },
  { value: 4.2, label: "pH: 4.2", color: AcceptenceCriteriaColors.Acceptable },
  { value: 4.1, label: "pH: 4.1", color: AcceptenceCriteriaColors.Acceptable },
  { value: 4.0, label: "pH: 4.0", color: AcceptenceCriteriaColors.Acceptable },
  { value: 3.9, label: "pH: <4.0", color: AcceptenceCriteriaColors.Acceptable },
];
